import React, { useRef } from "react";
import { AboutInnerBanner } from "../Components/Common/InnerBanner/AboutInnerBanner";
import AboutInnBanContent from "../Components/Common/InnerBanner/AboutInnBanContent";
import Transition from "../Components/Transition";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Helmet } from "react-helmet";
import { bookAppointment } from "../api/api";

const Appointment = () => {
  const { image, heading, pageName } = AboutInnBanContent.Appointment;
  const form = useRef();

  const formik = useFormik({
    initialValues: {
      aName: "",
      aEmail: "",
      aPhone: "",
      aService: "",
      aDepartment: "",
      aDoctorName: "",
      aDate: "",
      aTime: "",
    },

    validationSchema: Yup.object({
      aName: Yup.string().required("Name is required"),
      aEmail: Yup.string()
        .email("Invalid email")
        .required("Email required"),
      aPhone: Yup.string()
        .matches(/^[0-9]{10}$/, "Enter valid 10-digit number")
        .required("Phone required"),
      aService: Yup.string().required("Select service"),
      aDepartment: Yup.string().required("Select department"),
      aDoctorName: Yup.string().required("Select doctor"),
      aDate: Yup.string().required("Date required"),
      aTime: Yup.string().required("Time required"),
    }),

    onSubmit: async (values, { resetForm }) => {
      try {
        console.log("Sending:", values);

        const res = await bookAppointment(values);

        console.log("Response:", res.data);

        alert("Appointment booked successfully ✅");

        resetForm();
      } catch (error) {
        console.error(error);
        alert("API Error ❌");
      }
    },
  });

  return (
    <>
      <Helmet>
        <title>Best Booking Appointments | Acme Fertility Hospital</title>
      </Helmet>

      <AboutInnerBanner
        image={image}
        heading={heading}
        pageName={pageName}
      />

      <div className="appointment-area ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="apponitment-image"></div>
            </div>

            <div className="col-lg-8">
              <div className="appointment-from">
                <span>Appointment</span>
                <h3>Make An Appointment</h3>

                <form
                  ref={form}
                  onSubmit={formik.handleSubmit}
                  className="contact-from"
                >
                  <div className="row">

                    {/* Name */}
                    <div className="col-lg-6">
                      <input
                        type="text"
                        name="aName"
                        placeholder="Name"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.aName}
                      />
                      <div className="error">
                        {formik.touched.aName && formik.errors.aName}
                      </div>
                    </div>

                    {/* Email */}
                    <div className="col-lg-6">
                      <input
                        type="text"
                        name="aEmail"
                        placeholder="Email"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.aEmail}
                      />
                      <div className="error">
                        {formik.touched.aEmail && formik.errors.aEmail}
                      </div>
                    </div>

                    {/* Phone */}
                    <div className="col-lg-6">
                      <input
                        type="number"
                        name="aPhone"
                        placeholder="Phone"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.aPhone}
                      />
                      <div className="error">
                        {formik.touched.aPhone && formik.errors.aPhone}
                      </div>
                    </div>

                    {/* Service */}
                    <div className="col-lg-6">
                      <select
                        name="aService"
                        className="form-select"
                        onChange={formik.handleChange}
                        value={formik.values.aService}
                      >
                        <option value="">Service</option>
                        <option value="IVF">IVF</option>
                        <option value="PRP">PRP</option>
                        <option value="IUI">IUI</option>
                      </select>
                    </div>

                    {/* Department */}
                    <div className="col-lg-6">
                      <select
                        name="aDepartment"
                        className="form-select"
                        onChange={formik.handleChange}
                        value={formik.values.aDepartment}
                      >
                        <option value="">Department</option>
                        <option value="Fertility">Fertility</option>
                      </select>
                    </div>

                    {/* Doctor */}
                    <div className="col-lg-6">
                      <select
                        name="aDoctorName"
                        className="form-select"
                        onChange={formik.handleChange}
                        value={formik.values.aDoctorName}
                      >
                        <option value="">Doctor</option>
                        <option value="Dr. Neelam Bhise">Dr. Neelam Bhise</option>
                      </select>
                    </div>

                    {/* Date */}
                    <div className="col-lg-6">
                      <input
                        type="date"
                        name="aDate"
                        className="form-control"
                        onChange={formik.handleChange}
                        value={formik.values.aDate}
                      />
                      <div className="error">
                        {formik.touched.aDate && formik.errors.aDate}
                      </div>
                    </div>

                    {/* Time */}
                    <div className="col-lg-6">
                      <input
                        type="time"
                        name="aTime"
                        className="form-control"
                        onChange={formik.handleChange}
                        value={formik.values.aTime}
                      />
                      <div className="error">
                        {formik.touched.aTime && formik.errors.aTime}
                      </div>
                    </div>

                    {/* Button */}
                    <div className="col-lg-12">
                      <button type="submit" className="common-btn style1">
                        Book Now
                      </button>
                    </div>

                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Transition(Appointment);